export default __webpack_public_path__ + "a30afdc7e661e16e8123aba793ce67c8.png";